export type ItemCardConfig = {
  showSizes: boolean
  showColors: boolean
  showTags: boolean
}

export const getItemCardConfig = (style: string): ItemCardConfig => {
  // base64デコード
  const css = Buffer.from(style, 'base64').toString('utf-8')

  return {
    // item-card-size-list に display:flex が含まれるか
    showSizes:
      css.includes('.item-card-size-list') &&
      css.includes('display') &&
      css.includes('flex'),
    // item-card-color-code-list に display:flex が含まれるか
    showColors:
      css.includes('.item-card-color-code-list') &&
      css.includes('display') &&
      css.includes('flex'),
    // item-card-tag-list に display:flex が含まれるか
    showTags:
      css.includes('.item-card-tag-list') &&
      css.includes('display') &&
      css.includes('flex'),
  }
}
